import { globalEnv } from "@/constants";
import { Workbox } from "workbox-window";

let wb = null;

if ("serviceWorker" in navigator) {
  wb = new Workbox(`${globalEnv.baseUrl}service-worker.js`);

  wb.addEventListener("controlling", () => {
    window.location.reload();
  });

  wb.register().catch((error) => console.warn("Service worker registration failed:", error));
}

const workboxInstance = wb;
export default workboxInstance;
